import { BaseMapper } from '../shared/base.mapper';
import { PeriodContactability } from '../../types/period-contactability/periodContactability.type';
import { Injectable } from "@angular/core";

@Injectable()
export class PeriodContactabilityMapper extends BaseMapper<PeriodContactability> {

}
